import React from 'react';
import Link from '@mlb/react-patterns/components/Link/link';

import StatusTemplate from '../StatusTemplate';

const StatusMessage = () => (
    <StatusTemplate
        title={'Oops, something went wrong.'}
        message= {
            <>
                Try reloading the page. If the problem persists, please&nbsp;
                <Link
                    url={'https://mlb.az1.qualtrics.com/jfe/form/SV_6VAkPVhBsHZF8cR'}
                    target={'_blank'}
                >
                    Contact Us
                </Link>.
            </>
        }
    />
);

export default StatusMessage;
